/**
 * Typed, validated access to build-time configuration.
 *
 * Reading import.meta.env directly from components makes it impossible to see
 * what the app actually depends on. Everything funnels through here.
 */

function bool(value: string | undefined, fallback: boolean): boolean {
  if (value === undefined || value === "") return fallback;
  return value === "true" || value === "1";
}

function int(value: string | undefined, fallback: number): number {
  const n = Number.parseInt(value ?? "", 10);
  return Number.isFinite(n) ? n : fallback;
}

export const env = {
  apiBaseUrl: import.meta.env.VITE_API_BASE_URL ?? "/api",

  /**
   * Answer every request from the bundled demo dataset instead of the network.
   *
   * Defaults to **false**. It defaulted to true while /server did not exist,
   * which now fails in the worst possible direction: a production build with no
   * `.env.production` would silently ship a site serving fake data, with no
   * error anywhere to notice. Opting into mocks has to be explicit.
   */
  useMocks: bool(import.meta.env.VITE_USE_MOCKS, false),

  /** Artificial latency so loading and error states are exercised in dev. */
  mockLatency: int(import.meta.env.VITE_MOCK_LATENCY, 260),

  siteName: import.meta.env.VITE_SITE_NAME ?? "Indraprastha Engineers & Architects",
  siteUrl: import.meta.env.VITE_SITE_URL ?? "https://indraprastha.design",

  isDev: import.meta.env.DEV,
  isProd: import.meta.env.PROD,
} as const;

export type Env = typeof env;
